import { render, staticRenderFns } from "./BookEntries.vue?vue&type=template&id=16fbbbb4&scoped=true&"
import script from "./BookEntries.vue?vue&type=script&lang=js&"
export * from "./BookEntries.vue?vue&type=script&lang=js&"
import style0 from "./BookEntries.vue?vue&type=style&index=0&id=16fbbbb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbbbb4",
  null
  
)

export default component.exports